export const ANALYTICS_ENDPOINT = "/api/sjkdfladskh";
export const IS_PROD = true;